export const LOGGED_IN_USER_PROFILE_DATA = "LOGGED_IN_USER_PROFILE_DATA";
export const BEFORE_LOGIN_PATH = "BEFORE_LOGIN_PATH";

//Action Creator
export const setProfile = (data) => {
    return { type: LOGGED_IN_USER_PROFILE_DATA, data }
}

export const setPreURL = (path) => {
    return { type: BEFORE_LOGIN_PATH, path }
}